<template>
  <v-col cols="12">
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Time</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddProcedureStep(serie)">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels
      v-model="activeStepIndex"
      v-if="serie.procedures.length != 0"
    >
      <draggable
        v-model="serie.procedures[0].procedureSteps"
        @start="drag = true"
        @end="drag = false"
        handle=".draghandle"
        style="width: 100%"
      >
        <v-expansion-panel
          v-for="procedureStep in serie.procedures[0].procedureSteps"
          :key="procedureStep.id"
        >
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-fade-transition leave-absolute>
                <v-row no-gutters align="center">
                  <v-col>
                    <v-btn icon class="draghandle">
                      <v-icon>mdi-drag-horizontal</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="3">
                    <v-chip
                      v-if="procedureStep.time.mode == 'SCORING_TIME'"
                      small
                      color="primary"
                    >
                      SCORING
                    </v-chip>
                    <v-chip
                      v-if="procedureStep.time.mode == 'COUNTDOWN_TIME'"
                      small
                      color="primary"
                    >
                      COUNTDOWN
                    </v-chip>
                    <v-chip
                      v-if="procedureStep.time.mode == 'PREPARATION_TIME'"
                      small
                      color="primary"
                    >
                      PREPARATION
                    </v-chip>
                  </v-col>
                  <v-col cols="4">
                    <v-chip
                      v-if="checkTimeType(procedureStep.time) === 'BLOCK'"
                      small
                      color="primary"
                    >
                      BLOCK
                    </v-chip>

                    <v-chip
                      v-if="checkTimeType(procedureStep.time) === 'DOWN'"
                      small
                      color="primary"
                    >
                      Countdown
                    </v-chip>

                    <v-chip
                      v-if="checkTimeType(procedureStep.time) === 'UP'"
                      small
                      color="primary"
                    >
                      Countup
                    </v-chip>
                    <span v-if="open" key="0">
                      {{
                        timeType !== 'BLOCK'
                          ? procedureStep.time.from.defaultValue.value
                          : ''
                      }}
                      {{
                        procedureStep.time.to
                          ? ' - ' + procedureStep.time.to.defaultValue.value
                          : ''
                      }}
                    </span>
                    <span v-else key="1">
                      {{
                        checkTimeType(procedureStep.time) !== 'BLOCK'
                          ? procedureStep.time.from.defaultValue.value
                          : ''
                      }}
                      {{
                        procedureStep.time.to
                          ? ' - ' + procedureStep.time.to.defaultValue.value
                          : ''
                      }}
                    </span>
                  </v-col>
                  <v-spacer> </v-spacer>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon
                        @click="onDeleteProcedureStep(serie, procedureStep.id)"
                        >mdi-close-thick</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-row>
              </v-fade-transition>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>Type of counter</p>
            <v-radio-group
              @change="onTimeTypeChange($event, procedureStep.time)"
              v-model="timeType"
            >
              <v-radio label="Count down" value="DOWN"></v-radio>
              <v-radio label="Block time(Set to 00:00)" value="BLOCK"></v-radio>
              <v-radio label="Count up" value="UP"></v-radio>
            </v-radio-group>
            <v-col v-if="timeType == 'DOWN'" cols="3">
              <v-text-field
                v-model="procedureStep.time.from.defaultValue.value"
                label="Time from"
                placeholder="Time"
                :rules="
                  procedureStep.time.mode === 'PREPARATION_TIME'
                    ? timeRuleAllowNoTime
                    : timeRule
                "
              ></v-text-field>
            </v-col>
            <v-col v-if="timeType == 'UP' && procedureStep.time.to" cols="3">
              <v-text-field
                v-model="procedureStep.time.to.defaultValue.value"
                label="Time to"
                placeholder="Time"
                :rules="
                  procedureStep.time.mode === 'PREPARATION_TIME'
                    ? timeRuleAllowNoTime
                    : timeRule
                "
              ></v-text-field>
            </v-col>
            <v-toolbar color="grey lighten-3">
              <v-toolbar-title>Profiles</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn
                small
                fab
                color="primary"
                @click="onAddTimeProfile(procedureStep)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
            <v-expansion-panels v-if="!procedureStep.time.to">
              <v-expansion-panel
                v-for="(profile, index) in procedureStep.time.from
                  .profileValues"
                :key="index"
              >
                <v-expansion-panel-header>
                  <v-col cols="11">
                    <span> {{ profile.value.value }} </span>
                  </v-col>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon
                        @click="
                          onDeleteTimeProfile(index, procedureStep.time.from)
                        "
                        >mdi-close-thick</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row no-gutters>
                    <v-col cols="4">
                      <v-autocomplete
                        :items="getProfileObjectTable"
                        v-model="profile.id"
                        item-value="id"
                        item-text="value.value"
                        label="Profile"
                        required
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        v-model="profile.value.value"
                        item-value="value.value"
                        label="Time"
                        placeholder="Time"
                        :rules="timeRule"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- TO -->
            <v-expansion-panels v-if="procedureStep.time.to">
              <v-expansion-panel
                v-for="(profile, index) in procedureStep.time.to.profileValues"
                :key="index"
              >
                <v-expansion-panel-header>
                  <v-col cols="11">
                    <span> {{ profile.value.value }} </span>
                  </v-col>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon
                        @click="
                          onDeleteTimeProfile(index, procedureStep.time.to)
                        "
                        >mdi-close-thick</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row no-gutters>
                    <v-col cols="4">
                      <v-autocomplete
                        :items="getProfileObjectTable"
                        v-model="profile.id"
                        item-value="id"
                        item-text="value.value"
                        label="Profile"
                        required
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        v-model="profile.value.value"
                        item-value="value.value"
                        label="Time"
                        placeholder="Time"
                        :rules="timeRule"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <br />
            <p>Type</p>
            <v-radio-group v-model="procedureStep.time.mode">
              <v-radio label="Preparation" value="PREPARATION_TIME"></v-radio>
              <v-radio label="Countdown" value="COUNTDOWN_TIME"></v-radio>
              <v-radio label="Scoring" value="SCORING_TIME"></v-radio>
            </v-radio-group>

            <v-col cols="3">
              <p>Start Type</p>
              <v-select
                :items="startTypes"
                v-model="procedureStep.start"
                label="Start type"
              ></v-select>
            </v-col>

            <!-- CALLOUT -->
            <v-toolbar color="grey lighten-3">
              <v-toolbar-title>Callouts</v-toolbar-title>
              <v-spacer></v-spacer>
              <div class="error">{{ calloutErrorText }}</div>
              <v-btn
                small
                fab
                color="primary"
                @click="onAddCallout(procedureStep)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(callout, calloutIndex) in procedureStep.callouts"
                :key="calloutIndex"
              >
                <v-expansion-panel-header>
                  <v-col cols="11">
                    <span>
                      {{
                        audioTemplateName(callout.audioTemplateId.defaultValue)
                      }}
                    </span>
                  </v-col>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon
                        @click="
                          onDeleteAudioTemplate(
                            callout.audioTemplateId.defaultValue,
                            procedureStep,
                          )
                        "
                        >mdi-close-thick</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row no-gutters>
                    <v-col>
                      <v-select
                        :items="audioTemplates"
                        v-model="callout.audioTemplateId.defaultValue"
                        item-value="id"
                        item-text="name"
                        label="Audio template"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-radio-group
                        :disabled="isNoTime(procedureStep.time)"
                        v-model="callout.execution.mode"
                        class="ml-2"
                      >
                        <v-radio
                          label="From begin of time"
                          value="FROM_BEGIN"
                        ></v-radio>
                        <v-radio
                          label="From end of time"
                          value="FROM_END"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :disabled="isNoTime(procedureStep.time)"
                        v-model="callout.execution.time.defaultValue.value"
                        label="Time"
                        :rules="timeRule"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-radio-group
                        :disabled="isNoTime(procedureStep.time)"
                        v-model="callout.execution.executionTimingMode"
                        class="ml-2"
                      >
                        <v-radio
                          label="Start at time"
                          value="START_AT_TIME"
                        ></v-radio>
                        <v-radio
                          label="End at time"
                          value="FINISH_AT_TIME"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-checkbox
                      label="Wait until finished"
                      v-model="callout.execution.waitUntilFinished"
                    ></v-checkbox>
                  </v-row>

                  <!-- MEDIA -->
                  <v-row>
                    <v-toolbar color="grey lighten-3">
                      <v-toolbar-title>Media</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        fab
                        color="primary"
                        @click="onAddMedia(callout)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-expansion-panels>
                      <v-expansion-panel
                        v-for="(media, index) in callout.media"
                        :key="index"
                      >
                        <v-expansion-panel-header>
                          <template>
                            <v-fade-transition leave-absolute>
                              <v-row no-gutters align="center">
                                <v-chip
                                  v-if="showWhenTemplate(media)"
                                  small
                                  color="primary"
                                >
                                  {{
                                    getMediaTemplateName(media.mediaTemplateId)
                                  }}
                                </v-chip>
                                <v-chip
                                  small
                                  v-if="!showWhenTemplate(media)"
                                  color="primary"
                                >
                                  {{ media.mediaType }}
                                </v-chip>
                                <v-chip
                                  style="margin-left: 5px"
                                  small
                                  color="primary"
                                >
                                  {{ media.client.join(', ') }}
                                </v-chip>
                              </v-row>
                            </v-fade-transition>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-select
                            :items="mediaTemplates"
                            item-text="name"
                            item-value="id"
                            v-model="media.mediaTemplateId.defaultValue"
                            label="Media collection"
                          ></v-select>

                          <v-select
                            v-if="showMediaData(media)"
                            :items="['TEXT', 'IMAGE', 'AUDIO', 'VIDEO']"
                            v-model="media.mediaType"
                            label="Type"
                          ></v-select>
                          <v-select
                            v-if="showMediaData(media) && media.mediaType != ''"
                            :items="getMediaFormat(media.mediaType)"
                            v-model="media.mediaFormat"
                            label="Format"
                          ></v-select>
                          <v-select
                            :items="['E_MONITOR', 'E_SPECTATOR', 'E_CONTROL']"
                            v-model="media.client"
                            label="Client"
                            multiple
                          ></v-select>
                          <v-textarea
                            v-if="showMediaData(media, media.mediaFormat)"
                            v-model="media.mediaData.defaultValue"
                            label="Media Data"
                          ></v-textarea>
                          <!-- @onMediaData="text => media.mediaData.defaultValue = text" -->
                          <MarkdownEditor
                            :inputText="media.mediaData.defaultValue"
                            @onMediaData="
                              (text) => (media.mediaData.defaultValue = text)
                            "
                            v-if="media.mediaFormat == 'MARKDOWN'"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- Scoring state control -->
            <v-toolbar color="grey lighten-3 mt-5">
              <v-toolbar-title>Scoring state control</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                small
                fab
                color="primary"
                @click="onAddScoringStateControl(procedureStep)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(item, index) in procedureStep.scoringStateControl"
                :key="index"
              >
                <v-expansion-panel-header>
                  <v-col cols="11">
                    <span> {{ index + 1 }} - Repeat sequence [</span>
                    <span v-for="(step, index) in item.sequences" :key="index">
                      {{ formatSequenceSummary(step) }}
                      <span v-if="index < item.sequences.length - 1"> => </span>
                    </span>
                    <span>] {{ item.repeatCount }} times </span>
                  </v-col>
                  <v-col cols="1">
                    <v-btn icon>
                      <v-icon
                        @click="
                          onDeleteScoringStateControl(index, procedureStep)
                        "
                        >mdi-close-thick</v-icon
                      >
                    </v-btn>
                  </v-col>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- REPEAT COUNT -->
                  <div class="pa-2 my-3">
                    <v-text-field
                      v-model.number="item.repeatCount"
                      label="Repeat count"
                      type="number"
                      min="1"
                      prepend-icon="mdi-repeat"
                      class="input-field"
                    ></v-text-field>
                  </div>
                  <!-- SEQUENCES -->
                  <div class="d-flex flex-row">
                    <v-subheader>Sequences</v-subheader>
                    <v-spacer />
                    <v-btn
                      small
                      fab
                      color="primary"
                      @click="onAddScoringStateControlSequence(item)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                  <v-list>
                    <v-list-item
                      v-for="(sequence, index) in item.sequences"
                      :key="index"
                    >
                      <div class="d-flex flex-row align-center">
                        <v-select
                          v-model="sequence.validTargets"
                          :items="availableTargets"
                          label="Valid targets"
                          prepend-icon="mdi-target"
                          class="sequence-input mr-3"
                          multiple
                          small-chips
                          deletable-chips
                        />
                        <v-select
                          :items="['TIME']"
                          :value="
                            sequence.proceedCondition
                              ? sequence.proceedCondition.type
                              : 'TIME'
                          "
                          label="Condition"
                          class="input-field mr-3"
                          @change="
                            onProceedConditionTypeChange($event, sequence)
                          "
                        ></v-select>
                        <v-text-field
                          v-if="
                            sequence.proceedCondition &&
                            sequence.proceedCondition.type === 'TIME'
                          "
                          :value="
                            sequence.proceedCondition
                              ? sequence.proceedCondition.duration
                              : ''
                          "
                          @input="
                            (value) =>
                              onProceedConditionDurationChange(value, sequence)
                          "
                          :rules="positiveNonZeroNumber"
                          label="Duration"
                          class="input-field mr-3"
                          type="number"
                          min="1"
                          step="1"
                          suffix="ms"
                        ></v-text-field>
                        <v-btn icon class="ml-5">
                          <v-icon
                            @click="
                              onDeleteScoringStateControlSequence(index, item)
                            "
                            >mdi-delete</v-icon
                          >
                        </v-btn>
                      </div>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </draggable>
    </v-expansion-panels>
  </v-col>
</template>

<style lang="scss" scoped>
.input-field {
  max-width: 120px;
}

.sequence-input {
  flex: 1 1 0;
  max-width: none;
  min-width: 180px;
}
</style>

<script>
import * as helpers from '../../shootingProgramHelpers.js';
import { v4 as uuidv4 } from 'uuid';
import draggable from 'vuedraggable';
import MarkdownEditor from '../../../common/MarkdownEditor.vue';
import { GET_AUDIO_COLLECTION_FULL_QUERY } from '../../../../graphql/shootingProgramQueries.js';
export default {
  name: 'EditSeriesTimePanel',
  apollo: {
    $client: 'shootingProgramClient',
    getAudioCollections: {
      query: GET_AUDIO_COLLECTION_FULL_QUERY,
      variables() {
        // Reactive parameters
        return {
          id: this.calloutConfig?.audioCollectionId,
        };
      },
      loadingKey: 'loading',
      options: { fetchPolicy: 'cache-and-network' },
    },
  },
  components: {
    draggable,
    MarkdownEditor,
  },
  props: {
    profiles: Array,
    serie: Object,
    calloutConfig: Object,
    selectedAudioCollection: Object,
    selectedAudioProfileId: String,
    mediaTemplates: Array,
    requiredTargetCount: {
      type: Number,
      default: null,
    },
  },
  created() {
    //Fill callouts with missing values if exists.
    this.serie.procedures.forEach((procedure) => {
      if (!procedure.procedureSteps) procedure.procedureSteps = [];

      procedure.procedureSteps.forEach((step) => {
        if (!step.callouts) return;
        step.callouts.forEach((callout) => {
          if (!callout.execution.time) {
            callout.execution.mode = 'FROM_BEGIN';
            callout.execution.time = {
              defaultValue: {
                value: '00:00',
              },
            };
            callout.execution.executionTimingMode = 'START_AT_TIME';
          }
        });
      });
    });
  },
  computed: {
    availableTargets() {
      if (!this.requiredTargetCount || this.requiredTargetCount <= 0)
        return [1];

      return Array.from({ length: this.requiredTargetCount }, (_, i) => i + 1);
    },
    audioProfile() {
      if (
        this.audioCollection === null &&
        this.selectedAudioProfileId !== undefined
      )
        return [];

      const audioProfile = this.audioCollection?.audioProfiles.filter(
        (prof) => prof.id == this.selectedAudioProfileId,
      );

      return audioProfile.length === 1 ? audioProfile[0] : [];
    },
    audioCollection() {
      if (!this.selectedAudioCollection || !this.selectedAudioCollection.id) {
        return null;
      }

      return this.selectedAudioCollection.jsonData.audioCollection;
    },

    audioTemplates() {
      if (this.audioCollection === null && this.audioProfile === null)
        return [];

      return this.audioCollection?.audioTemplates.filter((template) =>
        this.audioProfile.sounds.some(
          (sound) => sound.audioTemplateId === template.id,
        ),
      );
    },
    getProfileObjectTable() {
      var profileObjects = [];
      this.profiles.map((profile, index) => {
        profileObjects[index] = {
          value: {
            value: profile.name.value,
          },
          id: profile.id,
        };
      });

      return profileObjects;
    },
  },

  watch: {
    activeStepIndex(newIndex) {
      if (newIndex != null) {
        const step = this.serie.procedures[0].procedureSteps[newIndex];
        if (step.time.to && step.time.from.defaultValue.value === '00:00') {
          this.onTimeTypeChange('UP', step.time);
          this.timeType = 'UP';
        } else if (step.time.from.defaultValue.value === '00:00') {
          this.onTimeTypeChange('BLOCK', step.time);
          this.timeType = 'BLOCK';
        } else {
          this.onTimeTypeChange('DOWN', step.time);
          this.timeType = 'DOWN';
        }
      }
    },
  },
  data: () => ({
    timeRule: [
      (v) =>
        helpers.validateTimeInput(v) || 'Incorrect time format - (HH:MM:SS)',
    ],
    timeRuleAllowNoTime: [
      (v) =>
        !v ||
        helpers.validateTimeInput(v) ||
        'Incorrect time format - (HH:MM:SS)',
    ],
    positiveNonZeroNumber: [
      (v) => {
        const numericValue = Number(v);
        return (
          (!Number.isNaN(numericValue) && numericValue > 0) ||
          'Must be a positive number'
        );
      },
    ],
    positiveNonZeroIntegerNumber: [
      (v) => /^(0*[1-9]\d*)$/.test(v) || 'Must be a positive integer',
    ],
    calloutErrorText: '',
    waitUntilFinished: false,
    startTypes: ['AUTO', 'WAIT_USER_INPUT'],
    timeType: 'DOWN',
    activeStepIndex: null,
  }),
  methods: {
    formatSequenceSummary(step) {
      const targets =
        step.validTargets && step.validTargets.length
          ? step.validTargets.join(', ')
          : '';

      const targetText = targets ? 'targets [' + targets + ']' : 'no targets';
      const duration =
        step.proceedCondition && step.proceedCondition.duration != null
          ? step.proceedCondition.duration
          : 0;
      return `${targetText} for ${duration}ms`;
    },
    onProceedConditionTypeChange(value, sequence) {
      if (!sequence.proceedCondition) {
        sequence.proceedCondition = {
          type: value,
          duration: null,
        };
      } else {
        sequence.proceedCondition.type = value;
      }
    },
    onTimeTypeChange(timeType, time) {
      if (timeType == 'UP') {
        if (!time.to) {
          time.to = {
            defaultValue: {
              value: '00:00',
            },
            profileValues: [],
          };
        }
        time.from.profileValues = [];
        time.from.defaultValue.value = '00:00';
      } else if (timeType == 'BLOCK') {
        time.from.profileValues = [];
        time.from.defaultValue.value = '00:00';
        time.to = null;
      } else time.to = null;
    },
    checkTimeType(time) {
      if (time.from && !time.to) {
        if (time.from.defaultValue.value != '00:00') return 'DOWN';
        else return 'BLOCK';
      } else return 'UP';
    },
    showWhenTemplate(media) {
      const name = this.getMediaTemplateName(media.mediaTemplateId);
      if (!name) {
        return false;
      } else return name != '';
    },
    getMediaTemplateName(templateId) {
      if (templateId) {
        const temps = this.mediaTemplates.find(
          (template) => template.id === templateId.defaultValue,
        );
        if (temps) {
          if (temps.id) return temps.name;
        }
      } else return '';
    },
    handleMediaCollectionChange(media, selectedItem) {
      if (!selectedItem || selectedItem.id === null) {
        media.mediaData.defaultValue = this.textareaValue;
      } else {
        media.mediaData.defaultValue = selectedItem;
      }
    },
    handleTextareaChange(media, newText) {
      this.textareaValue = newText;
      if (!media.mediaData.defaultValue || !media.mediaData.defaultValue.id) {
        media.mediaData.defaultValue = newText;
      }
    },
    showMediaData(media, mediaFormat) {
      return !media.mediaTemplateId.defaultValue && mediaFormat != 'MARKDOWN';
    },
    getMediaFormat(mediaType) {
      switch (mediaType) {
        case 'TEXT':
          return ['PLAIN', 'MARKDOWN'];
        case 'IMAGE':
          return ['SVG', 'PNG'];
        case 'AUDIO':
          return ['MP3'];
        case 'VIDEO':
          return ['VIDEO'];
        default:
          return [];
      }
    },
    isNoTime(time) {
      return (
        !time ||
        !time.from ||
        !time.from.defaultValue ||
        !time.from.defaultValue.value ||
        time.from.defaultValue.value === '0' ||
        time.from.defaultValue.value === '00' ||
        time.from.defaultValue.value === '00:00'
      );
    },
    audioTemplateName(id) {
      if (this.audioTemplates)
        return this.audioTemplates.filter((template) => template.id == id)[0]
          ?.name;
      else return '';
    },
    onAddProcedureStep(series) {
      if (series.procedureStep == undefined) {
        const procedureStep = {
          id: uuidv4(),
          executionCount: 1,
          procedureSteps: [],
        };
        series.procedures.push(procedureStep);
      }

      const prep = {
        id: uuidv4(),
        start: 'AUTO',
        time: {
          from: {
            defaultValue: {
              value: this.fromTimeToIsoTime('00:00'),
            },
            profileValues: [],
          },
          to: {
            defaultValue: {
              value: this.fromTimeToIsoTime('00:00'),
            },
            profileValues: [],
          },
          mode: 'PREPARATION_TIME',
        },
        callouts: null,
      };

      series.procedures[0].procedureSteps.push(prep);
    },

    onAddTimeProfile(procedureStep) {
      const procedureTime =
        this.timeType === 'UP'
          ? procedureStep.time.to
          : procedureStep.time.from;
      procedureTime.profileValues.push({
        value: {
          value: procedureTime.defaultValue.value,
        },
        id: '',
      });
    },
    onAddCallout(procedureStep) {
      if (
        procedureStep.callouts === undefined ||
        procedureStep.callouts === null
      ) {
        procedureStep.callouts = [];
      }

      const newCallout = {
        audioTemplateId: {
          defaultValue: '',
        },
        execution: {
          mode: 'FROM_BEGIN',
          time: {
            defaultValue: {
              value: '00:00',
            },
          },
          waitUntilFinished: false,
          executionTimingMode: 'START_AT_TIME',
        },
        media: [],
      };

      procedureStep.callouts.splice(
        procedureStep.callouts.length,
        0,
        newCallout,
      );
    },
    onAddMedia(callout) {
      if (!callout.media) {
        callout.media = [];
      }
      callout.media.push({
        mediaType: 'TEXT',
        mediaFormat: 'PLAIN',
        client: ['E_MONITOR'],
        mediaTemplateId: {
          defaultValue: null,
        },
        mediaData: {
          defaultValue: '',
        },
      });
    },
    onAddScoringStateControl(procedureStep) {
      // Initialize array if it doesn't exist
      if (!procedureStep.scoringStateControl) {
        procedureStep.scoringStateControl = [];
      }

      // Add a new scoring state control item
      procedureStep.scoringStateControl.splice(
        procedureStep.scoringStateControl.length,
        0,
        {
          repeatCount: 1,
          sequences: [],
        },
      );
    },
    onAddScoringStateControlSequence(scoringStateControlStep) {
      // Add a new scoring state control sequence
      scoringStateControlStep.sequences.splice(
        scoringStateControlStep.sequences.length,
        0,
        {
          validTargets: [],
          proceedCondition: {
            type: 'TIME',
            duration: 0,
          },
        },
      );
    },
    onProceedConditionDurationChange(value, sequence) {
      if (!sequence.proceedCondition) {
        sequence.proceedCondition = {
          type: 'TIME',
          duration: null,
        };
      }

      if (value === '' || value == null || Number.isNaN(+value)) {
        sequence.proceedCondition.duration = null;
      } else {
        sequence.proceedCondition.duration = Math.round(Number(value));
      }
    },
    onDeleteTimeProfile(index, procedureTime) {
      procedureTime.profileValues.splice(index, 1);
    },
    onDeleteAudioTemplate(calloutId, procedureStep) {
      procedureStep.callouts = procedureStep.callouts.filter(
        (callout) => callout.audioTemplateId.defaultValue !== calloutId,
      );
      return null;
    },
    onDeleteProcedureStep(series, id) {
      series.procedures[0].procedureSteps =
        series.procedures[0].procedureSteps.filter(
          (procedureStep) => procedureStep.id !== id,
        );
    },
    onDeleteScoringStateControl(index, procedureStep) {
      procedureStep.scoringStateControl.splice(index, 1);
    },
    onDeleteScoringStateControlSequence(index, scoringStateControlStep) {
      scoringStateControlStep.sequences.splice(index, 1);
    },
    fromTimeToIsoTime(time) {
      return helpers.fromTimeToIsoTime(time);
    },
  },
};
</script>
